export function importIntCountriesToSnipcart() {
    return [
        {
            name: "Canada",
            code: "CA",
            currencyCode: "CAD",
            featured: true,
            states: []
        },
        {
            name: "Brazil",
            code: "BR",
            currencyCode: "BRL",
            featured: false,
            states: []
        },
        {
            name: "China",
            code: "CN",
            currencyCode: "CNY",
            featured: false,
            states: []
        }
    ]
}

export function importEuCountriesToSnipcart() {
    return [
        {
            name: "Spain",
            code: "ES",
            currencyCode: "EUR",
            featured: false,
            states: []
        },
        {
            name: "Germany",
            code: "DE",
            currencyCode: "EUR",
            featured: false,
            states: []
        },
        {
            name: "Italy",
            code: "IT",
            currencyCode: "EUR",
            featured: false,
            states: []
        },
        {
            name: "France",
            code: "FR",
            currencyCode: "EUR",
            featured: false,
            states: []
        }
    ]
}

export function importUSCountriesToSnipcart() {
    return [
        {
            name: "United States",
            code: "US",
            currencyCode: "USD",
            featured: false,
            states: []
        }
    ]
}

export function importUKCountriesToSnipcart() {
    return [
        {
            name: "United Kingdom",
            code: "GB",
            currencyCode: "GBP",
            featured: false,
            states: []
        }
    ]
}